import {
  llmMagicGeneration,
  llmMagicGenerationFailure,
} from '@wandb/weave/integrations/analytics/llmEvents';

/**
 * Analytics configuration for LLM generation tracking.
 */
export type AnalyticsConfig = {
  /** The entity (organization) name */
  entity: string;
  /** The project name */
  project: string;
  /** The type of task being performed */
  task: string;
  /** The UI area where the request originated */
  area: string;
  /** Optional additional metadata */
  metadata?: Record<string, any>;
};

/**
 * Track LLM generation events with analytics.
 *
 * Safely handles analytics tracking with error handling to prevent
 * analytics failures from blocking the main functionality.
 *
 * @param config Analytics configuration parameters
 */
export const trackLLMGeneration = (config: AnalyticsConfig): void => {
  try {
    llmMagicGeneration({
      entity: config.entity,
      project: config.project,
      task: config.task,
      area: config.area,
      ...(config.metadata && {
        metadata: config.metadata,
      }),
    });
  } catch (error) {
    console.warn('Failed to track LLM generation event:', error);
  }
};

/**
 * Track LLM generation failure events with analytics.
 *
 * Safely handles analytics tracking with error handling to prevent
 * analytics failures from blocking the main functionality.
 *
 * @param config Analytics configuration parameters
 */
export const trackLLMFailure = (config: AnalyticsConfig): void => {
  try {
    llmMagicGenerationFailure({
      entity: config.entity,
      project: config.project,
      task: config.task,
      area: config.area,
      ...(config.metadata && {
        metadata: config.metadata,
      }),
    });
  } catch (error) {
    console.warn('Failed to track LLM failure event:', error);
  }
};
